<template>
	<span v-if="isNew" class="omapi-template-preview__new-badge om-new-badge">
		<slot>New</slot>
	</span>
</template>
<script>
import parseISO from 'date-fns/parseISO';
import subMonths from 'date-fns/subMonths';
export default {
	props: {
		createdDate: {
			type: String,
			default: '',
		},
	},
	computed: {
		isNew() {
			return parseISO(this.createdDate) > subMonths(new Date(), 3);
		},
	},
};
</script>
